export function getValue(value: unknown): string
{
	let number = Number(value);
	isNaN(number) &&
		(number = 0)

	return `calc(var(--spacing) * ${number})`
}